import { render, staticRenderFns } from "./Moshavers.vue?vue&type=template&id=1439734a&scoped=true&"
import script from "./Moshavers.vue?vue&type=script&lang=js&"
export * from "./Moshavers.vue?vue&type=script&lang=js&"
import style0 from "./Moshavers.vue?vue&type=style&index=0&id=1439734a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1439734a",
  null
  
)

export default component.exports